// ── Brand tokens (HOL Editorial Operations, Feb 2026) ──
export const BRAND = {
  bg: "#0A0A0A",
  surface: "#121212",
  surface2: "#1A1A1A",
  gold: "#D4AF37",
  goldSoft: "rgba(212, 175, 55, 0.65)",
  goldDim: "rgba(212, 175, 55, 0.20)",
  goldWhisper: "rgba(212, 175, 55, 0.08)",
  text: "#F7F7F7",
  textMuted: "rgba(247, 247, 247, 0.62)",
  textFaint: "rgba(247, 247, 247, 0.38)",
  hairline: "rgba(247, 247, 247, 0.08)",
};

// Motion timing
export const EASE_STAGE = [0.22, 1, 0.36, 1];
export const STAGE_STEP = 0.12;

// Layout
export const NAV_LOGO_SIZE = 40;
export const FONT_WEIGHT_SEMIBOLD = 600;

// Contact
export const CONTACT_EMAIL = "holcreativesolutions@gmail.com";
export const CONTACT_PHONE_DISPLAY = "(708) 658-4272";
export const CONTACT_PHONE_TEL = "+17086584272";

// Formspree
export const FORMSPREE_ENDPOINT = "https://formspree.io/f/xqewbqnj";

// Legacy tokens kept only because BlogPost / BlogIndex archive still uses them.
export const HERO_INNER_MAX = { blog: 860, blogIndex: 820, blogPostsGrid: 880 };
export const POST_BODY_MAX = 720;
export const POST_CTA_MARGIN_TOP = 56;
